import type { Role } from '@/data/types'

/**
 * Winner-golive All Logs → Strix Logs.
 *
 * Menu and route gates use the same table. TM + SM see CL Transfers and
 * Multiple Device Ids (SM Access Level catalogs those pages). Master sees six
 * pages; CL Transfers overlaps. DM sees no Logs group.
 */

export const LOG_PAGE_IDS = [
  'cl-transfers',
  'multiple-device-ids',
  'betfair-rates',
  'invalid-bets',
  'blocked-device-ids',
  'blocked-ip',
  'login-from-blocked-ip',
] as const

export type LogPageId = (typeof LOG_PAGE_IDS)[number]

/** Roles that may open each Logs page (Winner navigation.js filtering + SM Access Level). */
export const LOG_PAGE_ROLES: Record<LogPageId, readonly Role[]> = {
  'cl-transfers': ['triple-master', 'super-master', 'master'],
  'multiple-device-ids': ['triple-master', 'super-master'],
  'betfair-rates': ['master'],
  'invalid-bets': ['master'],
  'blocked-device-ids': ['master'],
  'blocked-ip': ['master'],
  'login-from-blocked-ip': ['master'],
}

export function canAccessLogPage(role: Role | undefined, pageId: LogPageId): boolean {
  if (!role) return false
  return LOG_PAGE_ROLES[pageId].includes(role)
}

export function logPagesForRole(role: Role | undefined): LogPageId[] {
  if (!role) return []
  return LOG_PAGE_IDS.filter((id) => canAccessLogPage(role, id))
}

/** True when the role should see the Logs nav group at all. */
export function canSeeLogsMenu(role: Role | undefined): boolean {
  return logPagesForRole(role).length > 0
}
